import React from "react";
import Preloader from "../../Global/Preloader";
import Headertwo from "../../Global/Headertwo";
import Innerpage from "../../Pages/MenAboutus/Innerpage";
import Aboutus from "../../Pages/MenAboutus/Aboutus";
import Whychooseus from '../../Home/Mainhomeone/Whychooseone';
import Testimonialtwo from "../../Home/Mainhometwo/Testimonialtwo";
import Teamone from "../../Home/Mainhomeone/Teamone";
import Ctaone from "../../Global/Ctaone";
import Footertwo from "../../Global/Footertwo";
import BackToTop from '../../Global/BackToTop';
import ServicesAbout from '../../Home/Mainhomeone/ServicesAbout'
import Footer from '../../Global/Footer';

const Main = () => {
    return(
        <>
        {/* <Preloader/> */}
        <Headertwo/>
        <Innerpage/>
        <ServicesAbout/>
        {/* <Aboutus/>
        <Whychooseus/>
        <Testimonialtwo/>
        <Teamone/>
        <Ctaone/> */}
        <Footer/>
       <BackToTop/>
        </>
    )
}
export default Main;